var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
/**
 * Lightweight DTO for office product assignments.
 * Contains only counter/summary fields needed for patient list views.
 * Cross-context usage: identity (patient list) reads from office-mgm context.
 */
export class OfficeProductAssignmentLiteDto {
    id;
    officeProductId;
    therameVideoCallsCount = null;
    therameExerciseProgramsCount = null;
    therameVideoCallsCompleted = null;
    therameVideoCallsReserved = null;
    therameExerciseProgramsCreated = null;
    totalRemainingTaskCount = 0;
    startedAt = null;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentLiteDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentLiteDto.prototype, "officeProductId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentLiteDto.prototype, "therameVideoCallsCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentLiteDto.prototype, "therameExerciseProgramsCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentLiteDto.prototype, "therameVideoCallsCompleted", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentLiteDto.prototype, "therameVideoCallsReserved", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentLiteDto.prototype, "therameExerciseProgramsCreated", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], OfficeProductAssignmentLiteDto.prototype, "totalRemainingTaskCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductAssignmentLiteDto.prototype, "startedAt", void 0);
//# sourceMappingURL=office-product-assignment.lite.dto.js.map